"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLineConfiguration = exports.LINE_WIDTH = void 0;
var tslib_1 = require("tslib");
var variables_1 = require("../_chartCreators/styles/variables");
var responsive_1 = require("../_chartCreators/responsive");
var common_1 = require("../_util/common");
exports.LINE_WIDTH = 3;
function getLineConfiguration(config, _definition, theme) {
    var _a, _b, _c, _d, _e;
    var lineConfiguration = {
        chart: {
            type: "line",
        },
        plotOptions: {
            series: {
                marker: {
                    symbol: "circle",
                    radius: 4.5,
                    lineColor: (_e = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.chart) === null || _a === void 0 ? void 0 : _a.backgroundColor) !== null && _b !== void 0 ? _b : (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _c === void 0 ? void 0 : _c.complementary) === null || _d === void 0 ? void 0 : _d.c0) !== null && _e !== void 0 ? _e : variables_1.styleVariables.gdColorBackground,
                },
                lineWidth: exports.LINE_WIDTH,
                fillOpacity: 0.3,
                states: {
                    hover: {
                        lineWidth: exports.LINE_WIDTH + 1,
                    },
                    inactive: {
                        opacity: 1,
                    },
                },
            },
            column: {
                dataLabels: {
                    enabled: true,
                },
            },
        },
        xAxis: [
            {
                categories: [],
            },
        ],
        yAxis: [
            {
                stackLabels: {
                    enabled: false,
                },
            },
        ],
    };
    if ((config === null || config === void 0 ? void 0 : config.enableCompactSize) && !(config === null || config === void 0 ? void 0 : config.zoomInsight)) {
        var _f = common_1.getAxesCounts(config), xAxesCount = _f[0], yAxesCount = _f[1];
        return tslib_1.__assign(tslib_1.__assign({}, lineConfiguration), { responsive: responsive_1.getCommonResponsiveConfig(false, xAxesCount, yAxesCount) });
    }
    return lineConfiguration;
}
exports.getLineConfiguration = getLineConfiguration;
//# sourceMappingURL=lineConfiguration.js.map